import React from 'react'
import Sidebar from '../components/Sidebar'
import Main from '../components/Main'

const Chat = () => {
  return (
    <div>
      <Sidebar />
      <Main/>

    </div>
  )
}

export default Chat